import { useMemo } from "react";
import { Link } from "react-router-dom";
import { Plus, ArrowRight, ShoppingBag } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { useStore } from "@/lib/store";
import { priceItems } from "@/lib/pricing";
import { CartLine } from "@/components/CartLine";
import { Totals } from "@/components/Totals";

export const useCartQuote = () => {
  const { items, settings } = useStore();
  return useMemo(() => (settings && items.length ? priceItems(items, settings) : null), [items, settings]);
};

export default function Cart() {
  const { t } = useLang();
  const { items, update, remove } = useStore();
  const quote = useCartQuote();

  if (!items.length)
    return (
      <div className="mx-auto flex max-w-xl flex-col items-center px-5 py-24 text-center" data-testid="cart-empty">
        <ShoppingBag className="h-12 w-12 text-slate-600" />
        <h1 className="mt-6 font-display text-4xl">{t("cart.title")}</h1>
        <p className="mt-3 text-slate-400">{t("cart.empty")}</p>
        <Link to="/order" className="btn-gold mt-8" data-testid="cart-start-btn">{t("cart.start")}</Link>
      </div>
    );

  return (
    <div className="mx-auto max-w-6xl px-5 py-12 lg:px-8" data-testid="cart-page">
      <h1 className="font-display text-4xl sm:text-5xl">{t("cart.title")}</h1>
      <div className="mt-10 grid gap-8 lg:grid-cols-[1fr_360px]">
        <div className="flex flex-col gap-3">
          {quote?.lines.map((l, i) => (
            <CartLine key={l.key} line={l} index={i} onQty={(q) => update(l.key, { quantity: q })} onRemove={() => remove(l.key)} />
          ))}
          <Link to="/order" className="btn-ghost mt-2 w-fit" data-testid="cart-add-more-btn"><Plus className="h-4 w-4" /> {t("cart.more")}</Link>
        </div>
        {quote && (
          <div>
            <Totals quote={quote}>
              <Link to="/checkout" className="btn-gold mt-6 w-full" data-testid="cart-checkout-btn">{t("cart.checkout")} <ArrowRight className="h-4 w-4" /></Link>
            </Totals>
          </div>
        )}
      </div>
    </div>
  );
}
